import { render, staticRenderFns } from "./zfPackage.vue?vue&type=template&id=c799ec8c&scoped=true"
import script from "./zfPackage.vue?vue&type=script&lang=js"
export * from "./zfPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c799ec8c",
  null
  
)

export default component.exports